import { useContext, useRef } from "react";
import MultiComparisonComponent from "../../Dashboard/Component/MultiComparisonComponent";
import { DiscoveryContext } from "../discovery-context";
import MUISelect from "../../../Component/UI/MUISelect/MUISelect";
import classes from "./MarketSummary.module.css";
import { AuthContext } from "../../../context/auth-context";

import { useIsSelectedSection } from "../discovery-context";
import { tab } from "../BrandScore/BrandScore";
import Checkbox from "@mui/material/Checkbox";

export default function MarketOverview() {

    const discoveryCtx = useContext(DiscoveryContext);
    const { user } = useContext(AuthContext);
    const customerId = user?.customer_id || 0;
    let primary_llm = discoveryCtx.primary_llm;
    let primaryMarket = discoveryCtx.markets[0];
    let llms = discoveryCtx.llm;
    const selectedCategory = discoveryCtx.state.selectedCategory
    const selectedMarket = discoveryCtx.state.selectdMarket;

    const id = "Market_Summary";
    /*we need to pass uniqueKey because it only selectedCategory*/
    let uniqueKey = `${id}_${selectedCategory}`;
    const { checked } = useIsSelectedSection({
        id,
        tab: tab.marketOverview,
        uniqueKey,
    });

    // const getBrandScores = (type) => {
    //     const brandScoresMap = {};
    //     // let mainBrandProduct = "";

    //     llms?.forEach((llm) => {
    //         const scores = discoveryCtx?.brand_scores?.[llm] || {};
    //         const markets = discoveryCtx?.markets || [];
    //         const categories = Object.keys(scores);

    //         categories?.forEach((category) => {
    //             const categoryScores = scores[category] || {};

    //             markets?.forEach((market) => {
    //                 const marketScores = categoryScores[market] || [];
    //                 const primaryMarketScore = categoryScores[primaryMarket]
    //                 if (!Array.isArray(marketScores) || marketScores.length === 0) {
    //                     console.warn(`No marketScores found for LLM "${llm}", category "${category}", market "${market}"`);
    //                     return;
    //                 }

    //                 // First valid entry sets the main brand product
    //                 // if (!mainBrandProduct) {
    //                 //     mainBrandProduct = marketScores[0].name;
    //                 // }

    //                 // Ensure nested objects exist before assignment
    //                 if (!brandScoresMap[llm]) {
    //                     brandScoresMap[llm] = {};
    //                 }
    //                 if (!brandScoresMap[llm][category]) {
    //                     brandScoresMap[llm][category] = {};
    //                 }

    //                 const marketValues = [
    //                     marketScores[0],
    //                     ...primaryMarketScore.slice(1)
    //                 ].map((item) => item[type]);
    //                 brandScoresMap[llm][category][market] = marketValues;
    //             });
    //         });
    //     });
    //     return { brandScoresMap };
    // };

    const getBrandScores = (type) => {
  const brandScoresMap = {};
  let mainBrandProduct = null; // track first valid brand

  if (!Array.isArray(llms) || llms.length === 0) {
    console.warn("No LLMs available in discoveryCtx");
    return { brandScoresMap, mainBrandProduct };
  }

  llms.forEach((llm) => {
    const scores = discoveryCtx?.brand_scores?.[llm] || {};
    const markets = discoveryCtx?.markets || [];
    const categories = Object.keys(scores || {});

    categories.forEach((category) => {
      const categoryScores = scores?.[category] || {};

      markets.forEach((market) => {
        const marketScores = categoryScores?.[market] || [];
        const primaryMarketScore = categoryScores?.[primaryMarket] || [];

        if (!Array.isArray(marketScores) || marketScores.length === 0) {
          console.warn(
            `No marketScores found for llm "${llm}", category "${category}", market "${market}"`
          );
          return;
        }

        if (!brandScoresMap[llm]) brandScoresMap[llm] = {};
        if (!brandScoresMap[llm][category]) brandScoresMap[llm][category] = {};

        // Choose safe values
        const marketValues = [
          ...(marketScores[0] ? [marketScores[0]] : []),
          ...(Array.isArray(primaryMarketScore)
            ? primaryMarketScore.slice(1)
            : []),
        ].map((item) =>
          item && type in item ? item[type] : null
        );

        // Set the first brand as mainBrandProduct
        if (!mainBrandProduct && marketScores[0]?.name) {
          mainBrandProduct = marketScores[0].name;
        }

        brandScoresMap[llm][category][market] = marketValues;
      });
    });
  });

  return { brandScoresMap, mainBrandProduct };
};

    const getIndexScoreMetaData = () => {
        const markets = discoveryCtx.markets;
        let indexScoreMetaData = [];
        llms.forEach((llm) => {
            markets.map((market) => {
                const brandIndexScores = discoveryCtx?.brand_scores?.[llm] || {};
                const categories = Object.keys(brandIndexScores);
                categories.map((category) => {

                    indexScoreMetaData[category] = {};
                    const marketScores = brandIndexScores[category] || {};
                    const primaryMarketScore = marketScores[market] || [];
                    indexScoreMetaData = indexScoreMetaData.concat(
                        primaryMarketScore.slice(0, 1).map((score) => {
                            return {
                                ...score,
                                category: category,
                                market: market,
                                llm: llm,
                                persona: "General Persona",
                                geography: ""
                            };
                        })
                    );
                });
            })
        })
        return indexScoreMetaData;
    };

    return (
        <>
            <div className="Heading-checkbox">
                <div className={classes.dropdownWrapper}>
                    <div style={{display:'flex', alignItems:'center'}}>
                    <h5>Market Summary</h5>
                     {discoveryCtx.state.showReportCheckbox && (
                    <Checkbox
                        checked={checked}
                        onChange={() => {
                            discoveryCtx?.clickComponentCheckbox({
                                uniqueKey,
                                filter: {
                                    id: id,
                                    title: "Market Summary",
                                    tab: tab.marketOverview,
                                    uniqueKey,
                                    llm:null,
                                    market:null
                                },
                                checked,
                                id,
                            });
                        }}
                        inputProps={{ "aria-label": "controlled" }}
                    />
                )}
                    </div>
                    <MUISelect
                        fullWidth={false}
                        optionValue={discoveryCtx.state.selectedCategory}
                        label={"Category"}
                        options={(discoveryCtx.category || []).map((category) => {
                            return {
                                name: category,
                                value: category,
                            };
                        })}
                        onChange={(e) => {
                            discoveryCtx.updateSelectedCategory(e.target.value);
                        }}
                    />
                </div>

               
            </div>
            <hr />
            <MultiComparisonComponent
                fetchRealTimeActionsSources={() => { }}
                sourceURLIds={[]}
                reachSourceData={{}}
                sentimentSourceData={{}}
                categoryDimensionRatingSource={{}}
                secCategoryIndexScoreMetaData={{}}
                coreAttSourceData={{}}
                positiveAttSource={{}}
                negativeAttSource={{}}
                customerId={1}
                selectedInput={{
                    llm: primary_llm,
                    market: selectedMarket,
                    persona: "General Persona",
                    brand: discoveryCtx.entity,
                    product: null,
                    geography: "",
                    category: selectedCategory,
                }}
                productTaxonomyData={null}
                secCategoryBrandFav={{}}
                secCategoryReach={{}}
                secCategoryBrandIndex={{}}
                indexScoreMetaData={getIndexScoreMetaData()}
                compCoreAttributes={{}}
                compCategoryDimensions={{}}
                pastCompCategoryDimensions={{}}
                pastCompCoreAttributes={{}}
                pastsecCategoryBrandIndex={{}}
                pastIndexScoreObj={{}}
                brandIndex={getBrandScores("total").brandScoresMap}
                brandReach={getBrandScores("rank").brandScoresMap}
                brandFav={getBrandScores("favorability").brandScoresMap}
                positiveAttributes={{}}
                negativeAttributes={{}}
                llmDomains={{}}
                geoLogo={{}}
                activeTab={"category"}
                brandDomains={{}}
                brandProduct={getBrandScores("favorability").mainBrandProduct}
                type={discoveryCtx.type == "brand" ? "Brand" : "Product"}
                brandProductCategory={discoveryCtx.markets}
                isBrandAuditPage={true}
                isBrandAuditMarketPage={true}
                isOverview={true}
                isMarketOverview={discoveryCtx.markets}
                id={id}
            />
        </>
    );
}
